import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    regionCountryChannel = new Subject();
    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    identityProvinceChannel = new Subject();
    identityCityChannel = new Subject();
    identityDistrictChannel = new Subject();
    identityVillageChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionCountry = async (query) => {
        this.regionCountryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCountry(query).then((result) => {
            this.regionCountryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCountryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityProvince = async (query) => {
        this.identityProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityProvince(query).then((result) => {
            this.identityProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityCity = async (query) => {
        this.identityCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityCity(query).then((result) => {
            this.identityCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityDistrict = async (query) => {
        this.identityDistrictChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityDistrict(query).then((result) => {
            this.identityDistrictChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityDistrictChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityVillage = async (query) => {
        this.identityVillageChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityVillage(query).then((result) => {
            this.identityVillageChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityVillageChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default CreateBloc